import type { Params } from 'react-router';

export function requestUsesRouteParam(requestURL: string, routeParams: Params) {
  const segments = new URL(requestURL, window.location.origin).pathname.split('/');

  return Object.entries(routeParams).some(([name, value]) => name !== '*' && value && segments.includes(value));
}
